<template>
    <div>
        <h2>Your account informations</h2>
        <form @submit.prevent="submit" ref="form" action="account/" data-method="put" class="white">
            <fieldset>
                <div class="form-group" v-bind:class="{'error': errors.company_name}">
                    <label for="settings-edit-company_name">Company name</label>
                    <input type="text" name="name" v-model="form.company_name" id="settings-edit-company_name" placeholder="Company name" :disabled="loadingVAT" />
                    <p v-if="errors.company_name" class="error">{{ errors.company_name }}</p>
                </div>
                <div class="form-group" v-bind:class="{'error': errors.company_details}">
                    <label for="settings-edit-company_details">Company address</label>
                    <textarea name="company_details" rows="4" cols="50" id="settings-edit-company_details" placeholder="Your company address, city and zipcode." autocomplete="off" v-model="form.company_details" :disabled="loadingVAT" ></textarea>
                    <p v-if="errors.company_details" class="error">{{ errors.company_details }}</p>
                </div>
                <div v-bind:class="{'row': isAvailableVat}">
                    <div class="form-group" v-bind:class="{'error': errors.country, 'col-6': isAvailableVat}">
                        <label for="settings-edit-country">Country</label>
                        <select id="settings-edit-country" name="country" placeholder="Your country" required v-model="form.country" :disabled="loadingVAT" >
                            <optgroup>
                                <option value="US">United States</option>
                                <option value="CA">Canada</option>
                                <option value="GB">United Kingdom</option>
                                <option value="FR">France</option>
                                <option value="DE">Germany</option>
                            </optgroup>
                            <optgroup label="-----------">
                                <option v-for="country in countries" v-bind:key="country.code" :value="country.code">{{ country.value }}</option>
                            </optgroup>
                        </select>
                        <p v-if="errors.country" class="error">{{ errors.country }}</p>
                    </div>
                    <div class="form-group col-6" v-bind:class="{'error': errors.company_vat}" v-if="isAvailableVat">
                        <label for="settings-edit-company_vat">EU VAT number</label>
                        <input type="text" placeholder="Your European VAT number " name="company_vat" v-model="form.company_vat" id="settings-edit-company_vat" @blur="loadVatDetails" :disabled="!isVatAllowed()" />
                        <p v-if="errors.company_vat" class="error">{{ errors.company_vat }}</p>
                    </div>
                </div>
            </fieldset>
            <div class="submit">
                <button-loader :disabled="disabled" :sending="sending" label="Update your details" />
            </div>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { countries, vatCountries } from '@/assets/countries'
import VueForm from '@/plugins/VueForm'
import ButtonLoader from '@/components/ButtonLoader'

export default {
    components: { ButtonLoader },
    mixins: [VueForm],
    data () {
        return {
            form: {
                company_name: null,
                company_details: null,
                company_vat: null,
                country: null
            },
            loadingVAT: false,
            countries: countries
        }
    },
    computed: {
        ...mapState({
            account: state => state
        }),
        isAvailableVat () {
            return vatCountries.indexOf(this.form.country) > -1
        }
    },
    watch: {
        account: {
            handler (to, from) {
                this.loadStore(to)
            },
            immediate: true
        }
    },
    methods: {
        loadStore (val) {
            if (typeof val !== 'object') {
                return
            }

            Object.keys(this.form).forEach(k => {
                if (k in val) {
                    this.$set(this.form, k, val[k])
                }
            })
        },
        processSubmit (body) {
            this.$store.commit('set', body.account)
            this.$router.push({ name: 'upgrade-payment', query: this.$route.query })
        },
        loadVatDetails () {
            if (!this.form.company_vat) {
                return false
            }
            this.loadingVAT = true
            this.$http.get('account/vat', { params: { number: this.form.company_vat } }).then(
                response => {
                    this.loadingVAT = false
                    if (!response.body.vat) {
                        return false
                    }

                    if (!this.form.company_name) {
                        this.form.company_name = response.body.vat.name
                    }
                    if (!this.form.company_details) {
                        this.form.company_details = response.body.vat.address
                    }
                    this.form.country = response.body.vat.countryCode
                },
                response => {
                    let error = 'We were unable to validate your EU VAT number.'
                    try {
                        error = response.body.errors.company_vat[0]
                    } catch (e) {}

                    this.$set(this.errors, 'company_vat', error)
                    this.loadingVAT = false
                }
            )
        },
        isVatAllowed () {
            return vatCountries.indexOf(this.form.country) > -1
        }
    }
}
</script>

<style lang="scss" scoped>
    form .submit {
        text-align: center;
        .btn {
            padding: 15px 40px;
        }
    }
</style>
